// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3XUFS","title":"FrontImage_title__2WH1A"};